/* Arflonia · Schnellfilter „Nur“ (2026-10-17)
   · Nur eine Produktart gleichzeitig: neuer Klick ersetzt die alte (Links kommen fertig aus Liquid)
   · Sofortiges Feedback beim Tippen, danach weiches Umsortieren der Knöpfe (FLIP) und sanftes Einblenden der Produkte
   · Pfeile + weiche Kanten, wenn die Knöpfe nicht in eine Zeile passen
   Laden/Neuzeichnen macht assets/arf-collection.js (data-arfc-link) */
(function () {
  'use strict';
  if (window.__arfQF) return;
  window.__arfQF = true;
  var D = document, pos = null;
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function chips(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-arfq-chip]')); }

  function init(scope) {
    Array.prototype.forEach.call((scope || D).querySelectorAll('[data-arfq]'), function (q) {
      var vp = q.querySelector('[data-arfq-vp]'); if (!vp) return;
      var prev = q.querySelector('[data-arfq-nav="-1"]'), next = q.querySelector('[data-arfq-nav="1"]');
      function upd() {
        var max = vp.scrollWidth - vp.clientWidth;
        var l = vp.scrollLeft > 4, r = max > 4 && vp.scrollLeft < max - 4;
        q.classList.toggle('is-l', l); q.classList.toggle('is-r', r);
        if (prev) prev.hidden = !l; if (next) next.hidden = !r;
      }
      if (!vp.__arfq) {
        vp.__arfq = 1;
        var raf = 0;
        vp.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; upd(); }); }, { passive: true });
        window.addEventListener('resize', upd);
      }
      upd(); setTimeout(upd, 250); setTimeout(upd, 1200);
    });
  }

  /* Tippen: sofort umfärben (Capture-Phase, vor arf-collection.js) */
  D.addEventListener('click', function (e) {
    var nav = e.target.closest && e.target.closest('[data-arfq-nav]');
    if (nav) {
      var q = nav.closest('[data-arfq]'), vp = q && q.querySelector('[data-arfq-vp]');
      if (vp) vp.scrollBy({ left: (parseInt(nav.getAttribute('data-arfq-nav'), 10) || 1) * Math.max(220, vp.clientWidth * 0.7), behavior: reduced() ? 'auto' : 'smooth' });
      return;
    }
    var a = e.target.closest && e.target.closest('[data-arfq-chip]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    var root = a.closest('[data-arfc]'); if (!root) return;
    pos = {};
    chips(root).forEach(function (c) { pos[c.getAttribute('data-key')] = c.getBoundingClientRect().left; });
    var wasOn = a.classList.contains('is-on');
    chips(root).forEach(function (c) { if (c !== a) c.classList.remove('is-on'); });
    a.classList.toggle('is-on', !wasOn);
    root.classList.add('arfq-switching');
  }, true);

  /* Nach dem Neuzeichnen: Knöpfe gleiten an ihren neuen Platz, Produkte blenden ein */
  D.addEventListener('arf:collection:updated', function () {
    var root = D.querySelector('[data-arfc]'); if (!root) return;
    root.classList.remove('arfq-switching');
    var vp = root.querySelector('[data-arfq-vp]'); if (vp) vp.scrollLeft = 0;
    init(root);
    if (pos && !reduced() && Element.prototype.animate) {
      chips(root).forEach(function (c) {
        var o = pos[c.getAttribute('data-key')];
        if (o === undefined) { c.animate([{ opacity: 0, transform: 'scale(.92)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'ease-out' }); return; }
        var dx = o - c.getBoundingClientRect().left;
        if (Math.abs(dx) < 1) return;
        c.animate([{ transform: 'translateX(' + dx + 'px)' }, { transform: 'none' }], { duration: 440, easing: 'cubic-bezier(.2,.8,.2,1)' });
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-arfc-grid] > li'), function (li, i) {
        if (i > 11) return;
        li.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 320, delay: Math.min(i, 8) * 30, easing: 'ease-out', fill: 'backwards' });
      });
    }
    pos = null;
  });

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); }); else init(D);
  window.addEventListener('load', function () { init(D); });
})();
